import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import {
  ROLE_ADMIN,
  ROLE_SALES,
  ROLE_SALES_AND_INVENTORY_MANAGER,
  ROLE_SALES_MANAGER,
  ROLE_SUPER_ADMIN
} from '../../helpers/constants';
import { userHasAnyRole } from '../../helpers/roleHelpers';
import NotFound from '../NotFound';
import CreateCrm from './CreateCrm';
import CRMDetails from './CrmDetails';
import CachedResponse from '../common/CachedResponse';

const CRM = () => {
  const getActivePage = () => {
    return (
      <Switch>
        <Route exact path="/crm/create">
          <CachedResponse listEndpoint={'app-choices'} render={appChoices => <CreateCrm appChoices={appChoices} />} />
        </Route>
        <Route
          exact
          path="/crm/search"
          render={({ location }) => <Redirect to={{ pathname: '/pipeline/crm', search: location.search }} />}
        />
        <Route exact path="/crm/:id">
          <CachedResponse listEndpoint={'app-choices'} render={appChoices => <CRMDetails appChoices={appChoices} />} />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    );
  };

  if (
    !userHasAnyRole(
      ROLE_SALES_MANAGER,
      ROLE_SALES,
      ROLE_SUPER_ADMIN,
      ROLE_ADMIN,
      ROLE_SALES_AND_INVENTORY_MANAGER
    )
  ) {
    return <NotFound text="You are not authorized to view this page" />;
  }

  return getActivePage();
};

export default CRM;
